regexService.$inject = [];

export default function regexService() {
  class RegexService {
    get email() { //eslint-disable-line
      return new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/);
    }
  }

  return new RegexService();
}



// WEBPACK FOOTER //
// ./src/services/regexService.js